import { UserRoleEnum } from '@app/admin/user/model/user.model';

export const UserRoleTranslations = {
  [UserRoleEnum.Admin]: 'global.roles.admin',
  [UserRoleEnum.Customer]: 'global.roles.customer'
};

